import styled from 'styled-components';

import Color from '../../styles/color';

export const Options = styled.div`
  margin-top: 30px;

  button {
    margin-top: 15px;
  }
`;

export const Content = styled.p`
  font-size: 15px;
  line-height: 22px;
  color: ${Color.neutral90};
  text-align: center;
  margin-top: 15px;
  display: flex;
  justify-content: center;
`;

export const Div = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
`;

export const ExpirationDate = styled.p`
  font-size: 14px;
  background-color: ${Color.alert};
  color: ${Color.white};
  font-weight: bold;
  align-items: center;
  justify-content: center;
  width: 190px;
  display: flex;
  height: 30px;
  border-radius: 8px;
  border: none;
  margin-top: 2px;
`;

export const Barcode = styled.p`
  font-size: 18px;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  width: 350px;
  display: flex;
  height: 75px;
  border: 2px dashed ${Color.neutral60};
  box-sizing: border-box;
  border-radius: 24px;
  margin-top: 18px;
  word-break: break-all;
  padding: 5px;
`;
